"use client";
import React, { useState } from "react";

const VideoModalButton = () => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  const handleCloseVideo = () => {
    setIsVideoOpen(false);
  };

  return (
    <>
      <button
        onClick={() => setIsVideoOpen(!isVideoOpen)}
        className={`sticky   ${
          !isVideoOpen
            ? "bg-black-600  hover:text-blue-500  "
            : "bg-red-600 dark:bg-red-600 hover:text-white"
        } text-black py-4 h-24 w-full px-6 shadow-lg transition dark:hover:text-white dark:bg-black dark:text-white  hover:opacity-100 bg-blue-500   font-bold dark:bg-blue-500 hover:dark:bg-blue-700  lg:text-xl  `}
      >
        {!isVideoOpen ? "🎥 Why Get An Appraisal?" : "Close Video"}
      </button>

      {/* Video Modal */}
      <div
        className={`  transition-transform duration-300 ${
          isVideoOpen
            ? "transform translate-y-0"
            : "transform translate-y-full hidden"
        }`}
      >
        <div className="bg-white dark:bg-gray-800  rounded-lg shadow-lg ">
          <div className="aspect-video ">
            <iframe
              width="100%"
              height="100%"
              src={
                isVideoOpen ? "https://player.vimeo.com/video/271555335" : ""
              }
              title="Home Appraisal Process Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default VideoModalButton;
